<template>
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">{{ $t(label) }}</label>
    </div>
    <div class="field-body copy-input" v-if="!copySuccessMsg">
      <input
        class="field input"
        :value="url"
        readonly
        @click="copyToClipboard"
      />
    </div>
    <div class="field-body" v-else>
      <input
        class="field input has-text-primary"
        :value="$t(copySuccessMsg)"
        readonly
      />
    </div>
  </div>
</template>

<script>
import { resetTimeout } from "@/utils"

const MSG_TIMEOUT_MS = 3000

export default {
  name: "field-horizontal",
  props: ["label", "url"],
  data() {
    return {
      copySuccessMsg: undefined
    }
  },
  methods: {
    copyToClipboard(event) {
      this.copySuccessMsg = undefined
      event.target.select()
      document.execCommand("copy")
      this.copySuccessMsg = "Copied to clipboard"
      resetTimeout(
        "copyToClipboard" + this.url,
        () => {
          this.copySuccessMsg = undefined
        },
        MSG_TIMEOUT_MS
      )
    }
  }
}
</script>

<style lang="scss">
.copy-input {
  ::selection {
    background: white;
  }
}
</style>
